import { getTokenImage } from '@vaultsfyi/common/utils'
import { RoundImage } from './roundImage'

interface TokenImageProps {
  symbol: string
  className?: string
}

export const TokenImage = ({ symbol, className }: TokenImageProps) => {
  return (
    <RoundImage src={getTokenImage(symbol)} fallback={getTokenImage('fallback')} alt={symbol} className={className} />
  )
}
